const normalizeValue = (value) =>
	value === null || value === undefined ? '' : String(value).trim()

const normalizeWarningLevel = (value) => {
	const level = normalizeValue(value)
	const normalizedLevel = level.toLowerCase()

	if (normalizedLevel === 'warning') return 'Warning'
	if (normalizedLevel === 'critical') return 'Critical'
	if (normalizedLevel === 'general') return 'General'
	return level || 'General'
}

export const getWarningResolutionHref = (value) => {
	const raw = normalizeValue(value)
	if (!raw) return ''

	const candidate = /^[a-z][a-z\d+.-]*:/i.test(raw) ? raw : `https://${raw}`

	try {
		const url = new URL(candidate)
		return ['http:', 'https:'].includes(url.protocol) && url.hostname
			? url.toString()
			: ''
	} catch {
		return ''
	}
}

export const parseUploadWarnings = (cell) => {
	const raw = normalizeValue(cell)
	if (!raw) return []

	try {
		const parsed = JSON.parse(raw)
		if (Array.isArray(parsed)) {
			return parsed
				.map((warning) => {
					if (!warning || typeof warning !== 'object') return null
					const title = normalizeValue(warning.title || warning.message)
					if (!title) return null

					const resolutionLink = normalizeValue(warning.resolutionLink)
					return {
						level: normalizeWarningLevel(warning.level),
						title,
						...(resolutionLink ? { resolutionLink } : {}),
					}
				})
				.filter(Boolean)
		}
	} catch {
		// Fall through to the Level:Title:Resolution URL CSV format.
	}

	return raw
		.split(',')
		.map((entry) => {
			const firstColon = entry.indexOf(':')
			if (firstColon === -1) {
				const title = normalizeValue(entry)
				return title ? { level: 'General', title } : null
			}

			const secondColon = entry.indexOf(':', firstColon + 1)
			const level = normalizeWarningLevel(entry.slice(0, firstColon))
			const title = normalizeValue(
				entry.slice(firstColon + 1, secondColon === -1 ? undefined : secondColon),
			)
			const resolutionLink =
				secondColon === -1 ? '' : normalizeValue(entry.slice(secondColon + 1))

			return title
				? {
						level,
						title,
						...(resolutionLink ? { resolutionLink } : {}),
					}
				: null
		})
		.filter(Boolean)
}
